import { render } from "./App.vue?vue&type=template&id=1cd9a720&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=1cd9a720&lang=scss"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__